/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends, __values } from "tslib";
import { Base, Point_$type, runOn, fromEnum, markType, PointUtil } from "igniteui-react-core";
import { ISeriesViewerInteractionManager_$type } from "./ISeriesViewerInteractionManager";
import { HighlightingManager } from "./HighlightingManager";
import { SeriesViewerScrollbarManager } from "./SeriesViewerScrollbarManager";
import { Rect } from "igniteui-react-core";
import { TileZoomManager } from "./TileZoomManager";
import { Size } from "igniteui-react-core";
import { MathUtil } from "igniteui-react-core";
import { MouseEventArgs } from "igniteui-react-core";
import { MouseButtonEventArgs } from "igniteui-react-core";
import { truncate, intDivide, isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var SeriesViewerInteractionManager = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(SeriesViewerInteractionManager, _super);
    function SeriesViewerInteractionManager() {
        var _this = _super.call(this) || this;
        _this.t = 0;
        _this.u = 0;
        _this.ai = null;
        _this.q = 0;
        _this.r = 0;
        _this.p = 0;
        _this.s = 0;
        _this.i = false;
        _this.aj = null;
        _this.al = null;
        _this.j = false;
        _this.l = false;
        _this.f = null;
        _this.b = null;
        _this.e = null;
        _this.ak = null;
        _this.am = null;
        _this.d = null;
        _this.a = null;
        _this.h = false;
        _this.ak = Rect.empty;
        _this.aj = Rect.empty;
        return _this;
    }
    Object.defineProperty(SeriesViewerInteractionManager.prototype, "f$b", {
        get: function () {
            if (this.b == null) {
                this.b = new HighlightingManager();
            }
            return this.b;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewerInteractionManager.prototype, "f$c", {
        get: function () {
            if (this.e == null) {
                this.e = new SeriesViewerScrollbarManager();
            }
            return this.e;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewerInteractionManager.prototype.f$ao = function (a, b) {
        var c = null;
        var d = null;
        var e = null;
        e = a.cu.e();
        var f;
        var g = ((function () { var h = a.cu.f(b, false, f, false); f = h.p2; return h.ret; })());
        if (g != e) {
            if (e != null && e.a6.a$c) {
                e.a6.a$z(e, b, null, null, false);
            }
        }
        c = f;
        if (a != null) {
            a.o0(b);
        }
        if (g != null && !g.a6.a$c) {
            g.a6.a$y(g, b, c, d, false);
        }
    };
    SeriesViewerInteractionManager.prototype.f$a = function (a) {
        if (a.av != 0) {
            return a.av;
        }
        var b = 1;
        var c = false;
        var d = false;
        for (var e = 0; e < a.series.count; e++) {
            var f = a.series._inner[e];
            if (f.isStacked) {
                f.ld(function (g) {
                    if (g.bo == 2) {
                        c = true;
                    }
                    if (g.bo == 1) {
                        d = true;
                    }
                    return true;
                });
            }
            else {
                if (f.bo == 2) {
                    c = true;
                }
                if (f.bo == 1) {
                    d = true;
                }
            }
        }
        if (d) {
            b = 1;
        }
        if (c) {
            b = 2;
        }
        if (c && d) {
            b = 3;
        }
        return b;
    };
    SeriesViewerInteractionManager.prototype.f$an = function (a) {
        var b = a.s0;
        var c = b;
        var d = a.cu;
        var e = a.dq();
        var f = a.dt;
        var g = a.e4;
        var h = a.fd;
        if (!e) {
            c = { $type: Point_$type, x: NaN, y: NaN };
        }
        if (c.x < 0 || c.x > 1 || c.y < 0 || c.y > 1) {
            c = { $type: Point_$type, x: NaN, y: NaN };
        }
        for (var i = 0; i < a.series.count; i++) {
            var j = a.series._inner[i];
            j.lk(c);
        }
        a.mc(c);
        var k = a.cl == 0 && !a.eb && (a.dz || f) && !g && !h;
        var l = a.to;
        if (k && !isNaN_(b.x) && !l.isEmpty) {
            var m = l.width * (b.x - a.s9.left) / a.s9.width;
            d.eo(l.left + m, l.top, l.left + m, l.bottom);
            d.ed();
            d.ei(m);
        }
        else {
            d.cl();
        }
        if (k && !isNaN_(b.y) && !l.isEmpty) {
            var n = l.height * (b.y - a.s9.top) / a.s9.height;
            d.eh(l.left, l.top + n, l.right, l.top + n);
            d.d9();
        }
        else {
            d.cg();
        }
    };
    SeriesViewerInteractionManager.prototype.f$ag = function (a) {
        switch (a.cl) {
            case 0:
                a.cu.d5();
                this.f$an(a);
                a.cu.cd();
                break;
            case 1:
                a.cu.d7();
                a.cu.ck();
                this.f$an(a);
                a.cu.cc();
                break;
            case 2:
                a.cu.d7();
                a.cu.ck();
                this.f$an(a);
                a.cu.ce();
                break;
        }
    };
    SeriesViewerInteractionManager.prototype.f$q = function (a, b) {
        if (b.x >= 0 && b.y >= 0 && b.x <= a.to.width && b.y <= a.to.height) {
            this.ae(a, b);
        }
        else {
            a.lz();
        }
    };
    SeriesViewerInteractionManager.prototype.ae = function (a, b) {
        var e_1, _a;
        var c = a.cu;
        var d = a.to;
        if (a.ec || a.eb) {
            return;
        }
        if (a.dt && a.dz) {
            var e = d.height > d.width;
            c.bv(e);
            try {
                for (var _b = __values(fromEnum(a.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var f = _c.value;
                    if (f.isStacked) {
                        f.ld(function (g) {
                            if (g._visibility == 0) {
                                g.ms(b, runOn(c, c.bm));
                            }
                            return true;
                        });
                    }
                    else {
                        if (f._visibility == 0) {
                            f.ms(b, runOn(c, c.bm));
                        }
                    }
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
            c.ea();
        }
    };
    SeriesViewerInteractionManager.prototype.ad = function (a, b) {
        if (a.dz || a.d9) {
            a.dt = true;
            a.nw();
            this.aj = new Rect(0, b.x, b.y, 0, 0);
            this.al = new Rect(0, b.x, b.y, 0, 0);
            a.cl = 0;
            a.lq(a.s3(b));
        }
    };
    SeriesViewerInteractionManager.prototype.f$ae = function (a, b) {
        this.ad(a, b);
        this.ae(a, b);
        this.f$an(a);
    };
    SeriesViewerInteractionManager.prototype.f$r = function (a, b, c) {
        if (!a.dt) {
            this.ag(a, b, c);
        }
    };
    SeriesViewerInteractionManager.prototype.f$p = function (a, b) {
        this.ak = Rect.empty;
        a.lz();
    };
    SeriesViewerInteractionManager.prototype.f$al = function (a) {
        if (this.j) {
            this.f$c.onScrollbarDragCancel();
            this.j = false;
        }
        var b = a.cu;
        this.s = 1;
        this.ac(a);
        a.cl = 0;
        this.i = true;
        a.e4 = true;
        a.nx();
    };
    SeriesViewerInteractionManager.prototype.ac = function (a) {
        var b = a.cu;
        a.dt = false;
        b.cj();
        b.cf();
        b.ch();
        a.lq({ $type: Point_$type, x: NaN, y: NaN });
        b.cg();
        b.cl();
        b.ck();
    };
    SeriesViewerInteractionManager.prototype.f$ad = function (a, b) {
        this.f$al(a);
    };
    SeriesViewerInteractionManager.prototype.f$am = function (a, b, c, d, e) {
        this.t = b.x;
        this.u = b.y;
        this.q = c;
        this.r = d;
        this.p = e;
        this.ai = a.s9;
        this.f$al(a);
    };
    SeriesViewerInteractionManager.prototype.f$ac = function (a, b) {
        var c = a.cu;
        c.cg();
        c.cl();
        if (c.av) {
            this.y(a, b);
        }
        else {
            this.aa(a, b);
            this.s = b;
        }
    };
    SeriesViewerInteractionManager.prototype.f$ai = function (a, b, c, d, e) {
        var f = a.cu;
        f.cg();
        f.cl();
        this.q = this.q * c;
        this.r = this.r * d;
        this.p = this.p * e;
        if (a.ei) {
            this.q = this.p;
            this.r = this.p;
        }
        var g = a.s9;
        var h = a.to;
        var i = b.x - this.t;
        var j = b.y - this.u;
        this.t = b.x;
        this.u = b.y;
        var k = g.width;
        var l = g.height;
        var m = this.ai.width / this.q;
        var n = this.ai.height / this.r;
        if (m > 1) {
            m = 1;
        }
        if (n > 1) {
            n = 1;
        }
        var o = { $type: Point_$type, x: b.x, y: b.y };
        var p = { $type: Point_$type, x: (o.x - h.left) / h.width * g.width + g.left, y: (o.y - h.top) / h.height * g.height + g.top };
        var q = new Rect(0, g.left, g.top, m, n);
        var r = { $type: Point_$type, x: (p.x - q.left) / q.width * h.width + h.left, y: (p.y - q.top) / q.height * h.height + h.top };
        var s = (r.x - o.x) - i;
        var t = (r.y - o.y) - j;
        var u = s / h.width * q.width;
        var v = t / h.height * q.height;
        q = new Rect(0, q.left + u, q.top + v, q.width, q.height);
        g = q;
        a.ph(g, true);
    };
    SeriesViewerInteractionManager.prototype.f$z = function (a, b) {
        this.aj = new Rect(0, b.x, b.y, 0, 0);
        this.al = new Rect(0, b.x, b.y, 0, 0);
    };
    SeriesViewerInteractionManager.prototype.z = function (a, b, c) {
        var d = a.s9.width;
        var e = a.s9.height;
        var f = a.s9.left + d / 2;
        var g = a.s9.top + e / 2;
        d = d / b;
        e = e / b;
        var h = f - d / 2;
        var i = g - e / 2;
        a.ph(new Rect(0, h, i, d, e), true);
    };
    SeriesViewerInteractionManager.prototype.f$ab = function (a, b) {
        var c = a.cu;
        if (c.av) {
            this.y(a, b);
        }
        else {
            this.aa(a, b);
        }
        this.aj = Rect.empty;
        a.e4 = false;
    };
    SeriesViewerInteractionManager.prototype.f$s = function (a, b) {
        a.e4 = false;
        this.aj = Rect.empty;
        a.lz();
    };
    SeriesViewerInteractionManager.prototype.f$y = function (a, b) {
        a.lm();
    };
    SeriesViewerInteractionManager.prototype.f$ah = function (a, b, c, d, e) {
        a.e4 = false;
        this.aj = Rect.empty;
        a.lz();
    };
    SeriesViewerInteractionManager.prototype.y = function (a, b) {
        var c = a.tp;
        var d = 1 / b;
        var e = { $type: Point_$type, x: c.x + c.width / 2, y: c.y + c.height / 2 };
        var f = { $type: Point_$type, x: c.x - e.x, y: c.y - e.y };
        var g = new Rect(0, f.x * d + e.x, f.y * d + e.y, c.width * d, c.height * d);
        a.ph(g, true);
    };
    SeriesViewerInteractionManager.prototype.aa = function (a, b) {
        var c = a.to;
        var d = a.tp;
        var e = b - this.s;
        if (e != 0) {
            var f = 0.03;
            var g = e < 0 ? 1 + f : 1 - f;
            var h = { $type: Point_$type, x: d.x + d.width / 2, y: d.y + d.height / 2 };
            var i = { $type: Point_$type, x: d.x - h.x, y: d.y - h.y };
            var j = new Rect(0, i.x * g + h.x, i.y * g + h.y, d.width * g, d.height * g);
            a.ph(j, true);
        }
    };
    SeriesViewerInteractionManager.prototype.f$n = function (a, b, c) {
        if (!a.e4) {
            this.i = false;
        }
        var d = false;
        if (a.du) {
            if (this.f$c.shouldHandleInteraction(b, c)) {
                this.j = true;
                d = true;
                this.ac(a);
                a.cu.dr();
                return;
            }
        }
        this.ag(a, b, c);
        a.ng(b, c);
    };
    SeriesViewerInteractionManager.prototype.ag = function (a, b, c) {
        var d;
        var e = a.cu;
        var f = a.cj(c);
        if (e.ez == 0) {
            switch (f) {
                case 1:
                    d = a.eq() ? f : 0;
                    break;
                default:
                    d = f;
                    break;
            }
        }
        else {
            if (e.ez == a.r9) {
                d = 1;
            }
            else if (e.ez == a.sa) {
                d = 2;
            }
            else {
                d = 0;
            }
        }
        switch (d) {
            case 1:
            case 2:
                a.cu.ca();
                a.cu.dr();
                break;
        }
        a.cl = d;
        switch (a.cl) {
            case 1:
                a.lq({ $type: Point_$type, x: NaN, y: NaN });
                this.aj = new Rect(0, b.x, b.y, 0, 0);
                this.al = new Rect(0, b.x, b.y, 0, 0);
                this.ak = new Rect(0, b.x, b.y, 0, 0);
                e.d8();
                e.eg(this.aj);
                a.n2(Rect.empty, true);
                break;
            case 2:
                this.aj = new Rect(0, b.x, b.y, 0, 0);
                this.ak = new Rect(0, b.x, b.y, 0, 0);
                break;
        }
        this.am = a.s9;
        a.tq = a.s9;
    };
    SeriesViewerInteractionManager.prototype.f$ak = function (a) {
        a.o1();
        a.cu.dl();
    };
    SeriesViewerInteractionManager.prototype.f$aj = function (a) {
        a.lu();
        a.cu.dk();
    };
    SeriesViewerInteractionManager.prototype.f$ap = function (a) {
        if (a.dp && !this.l) {
            this.l = true;
            this.af(a);
        }
    };
    SeriesViewerInteractionManager.prototype.f$k = function (a) {
        if (this.l) {
            this.ab(a);
            this.l = false;
        }
    };
    SeriesViewerInteractionManager.prototype.f$h = function (a) {
        if (this.f == null) {
            return;
        }
        this.g.ab();
    };
    Object.defineProperty(SeriesViewerInteractionManager.prototype, "g", {
        get: function () {
            return this.f;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewerInteractionManager.prototype.af = function (a) {
        if (this.f == null) {
            this.f = new TileZoomManager(a, true, a.hs);
            this.f.h = !a.e5;
        }
        a.d8 = true;
        a.n1();
        this.f.al();
        a.cu.br();
        a.cu.bs();
    };
    SeriesViewerInteractionManager.prototype.ab = function (a) {
        if (this.f == null) {
            return;
        }
        a.d8 = false;
        a.cu.dg();
        this.f.ah();
        a.ol();
        a.cu.by();
    };
    SeriesViewerInteractionManager.prototype.f$j = function (a) {
        a.lo();
        a.on();
    };
    SeriesViewerInteractionManager.prototype.n = function (a) {
        return a.cl == 2;
    };
    SeriesViewerInteractionManager.prototype.o = function (a, b) {
        return a.cb == 1 || b || a.dp;
    };
    SeriesViewerInteractionManager.prototype.m = function (a) {
        return a.cl == 1;
    };
    SeriesViewerInteractionManager.prototype.f$m = function (a, b, c) {
        var d = a.cu;
        if (this.j) {
            a.ba.onScrollbarDrag(b, c);
            return;
        }
        if (this.aj.isEmpty && c) {
            this.ag(a, b, c);
        }
        var e = 2;
        if (c) {
            e = 10;
        }
        var f = false;
        var g = new Rect(2, { $type: Point_$type, x: this.aj.x, y: this.aj.y }, b);
        var h = new Rect(0, 0, 0, 0, 0);
        if (!this.ak.isEmpty) {
            h = new Rect(2, { $type: Point_$type, x: this.ak.x, y: this.ak.y }, b);
        }
        if (h.width > e && h.height > e) {
            f = true;
        }
        if (!a.e4) {
            if (f) {
                this.i = false;
            }
        }
        if (!a.e4 && (a.dt || !c)) {
            a.lq(a.s3(b));
        }
        if (this.m(a)) {
            if (f) {
                var i = a.tn(g);
                a.n2(i, true);
            }
            else {
                a.n2(Rect.empty, true);
            }
            a.mp();
            d.eg(g);
        }
        var j = a.to;
        var k = a.s9;
        if (this.n(a)) {
            var l = j;
            var m = k.left + k.width * (this.aj.x - b.x) / l.width;
            var n = k.top + k.height * (this.aj.y - b.y) / l.height;
            var o = new Rect(0, m, n, k.width, k.height);
            if (this.o(a, c)) {
                if (h.width != 0 || h.height != 0) {
                    a.nx();
                }
                a.n2(Rect.empty, true);
                var p = a.s9;
                a.ph(o, true);
                var q = a.s9;
                if (p.equals1(q) && a.cu.k.ac) {
                    a.cu.k.au();
                }
                this.aj = new Rect(3, b, new Size(1, 0, 0));
                this.al = new Rect(3, b, new Size(1, 0, 0));
            }
            else {
                a.n2(o, true);
            }
        }
        this.al = new Rect(3, b, new Size(1, 0, 0));
        d.bu(b);
    };
    SeriesViewerInteractionManager.prototype.f$l = function (a, b, c, d) {
        var e = a.cu;
        var f = 2;
        if (c) {
            f = 10;
        }
        var g = a.to;
        var h = a.s9;
        if (!d) {
            if (this.j) {
                this.f$c.onScrollbarDragComplete(b, c);
                this.j = false;
                e.bw();
                return;
            }
        }
        if (!this.i) {
            var i = false;
            var j = new Rect(2, { $type: Point_$type, x: this.aj.x, y: this.aj.y }, b);
            if (j.width > f && j.height > f) {
                i = true;
            }
            if (a.cl == 1) {
                a.mo();
                e.cf();
                if (i) {
                    a.ph(a.tn(j), true);
                }
            }
            if (a.cl == 2) {
                var k = g;
                var l = h.left + h.width * (this.aj.x - b.x) / k.width;
                var m = h.top + h.height * (this.aj.y - b.y) / k.height;
                a.ph(new Rect(0, l, m, h.width, h.height), true);
            }
        }
        var n = false;
        var o = new Rect(2, { $type: Point_$type, x: this.ak.x, y: this.ak.y }, b);
        if (o.width > f || o.height > f) {
            n = true;
        }
        if (n) {
            a.fd = true;
        }
        a.cl = 0;
        a.n2(Rect.empty, true);
        e.bw();
        a.fd = false;
        e.cg();
        e.cl();
        if (c) {
            e.ck();
            e.cg();
            e.cl();
            e.ch();
        }
        a.lz();
        a.nw();
        a.nh(b, c, d);
    };
    SeriesViewerInteractionManager.prototype.f$af = function (a) {
        if (this.g != null) {
            this.g.h = !a.e5;
        }
    };
    SeriesViewerInteractionManager.prototype.f$e = function (a, b) {
        var c = a.cu;
        var d = a.s9;
        if (a.cl == 2 && b == 8) {
            c.bt();
            a.cl = 0;
            a.nw();
            a.n2(Rect.empty, true);
            if (a.cb == 1) {
                a.ph(this.am, true);
            }
            return true;
        }
        if (a.cl == 1 && b == 8) {
            c.bt();
            a.cl = 0;
            a.nw();
            c.cf();
            a.n2(Rect.empty, true);
            return true;
        }
        var e = Rect.empty;
        var f = false;
        switch (b) {
            case 13:
                f = true;
                e = new Rect(0, 0, 0, 1, 1);
                break;
            case 11:
                f = true;
                e = new Rect(0, d.left - 0.1 * d.width, d.top - 0.1 * d.height, 1.2 * d.width, 1.2 * d.height);
                break;
            case 10:
                f = true;
                e = new Rect(0, d.left + 0.1 * d.width, d.top + 0.1 * d.height, 0.8 * d.width, 0.8 * d.height);
                break;
            case 14:
                f = true;
                e = new Rect(0, d.left - 0.1 * d.width, d.top, d.width, d.height);
                e.x = e.x - Math.min(e.left, 0);
                break;
            case 16:
                f = true;
                e = new Rect(0, d.left + 0.1 * d.width, d.top, d.width, d.height);
                e.x = e.x - Math.max(e.right - 1, 0);
                break;
            case 15:
                f = true;
                e = new Rect(0, d.left, d.top - 0.1 * d.height, d.width, d.height);
                e.y = e.y - Math.min(e.top, 0);
                break;
            case 17:
                f = true;
                e = new Rect(0, d.left, d.top + 0.1 * d.height, d.width, d.height);
                e.y = e.y - Math.max(e.bottom - 1, 0);
                break;
        }
        if (!e.isEmpty && Rect.l_op_Inequality(e, d)) {
            a.ph(e, true);
        }
        return f;
    };
    SeriesViewerInteractionManager.prototype.f$f = function (a, b, c) {
        var d = a.cu;
        var e = a.s9;
        var f = e.left + e.width * b.x / a.to.width;
        var g = e.top + e.height * b.y / a.to.height;
        var h = 1 - MathUtil.d(c, -0.5, 0.5);
        var i = Math.max(0, f - h * (f - e.left));
        var j = Math.min(1, g + h * (e.bottom - g));
        var k = Math.min(1, f + h * (e.right - f));
        var l = Math.max(0, g - h * (g - e.top));
        a.nx();
        this.x(a, 1000);
        a.ph(new Rect(0, i, l, k - i, j - l), true);
        return a.eq();
    };
    SeriesViewerInteractionManager.prototype.x = function (a, b) {
        a.cu.bz(b);
    };
    SeriesViewerInteractionManager.prototype.f$o = function (a, b) {
        var c = a.s9;
        var d = c.left + c.width * b.x / a.to.width;
        var e = c.top + c.height * b.y / a.to.height;
        var f = 0.7;
        var g = Math.max(0, d - f * (d - c.left));
        var h = Math.min(1, e + f * (c.bottom - e));
        var i = Math.min(1, d + f * (c.right - d));
        var j = Math.max(0, e - f * (e - c.top));
        a.ph(new Rect(0, g, j, i - g, h - j), true);
    };
    SeriesViewerInteractionManager.prototype.f$i = function (a) {
        this.g.ac();
    };
    SeriesViewerInteractionManager.prototype.f$d = function (a, b, c, d, e, f, g) {
        var e_2, _a;
        var h = true;
        var i = false;
        var j = false;
        var k = a;
        if (k.au == 1) {
            h = false;
            i = true;
        }
        if (k.au == 3 || k.au == 4) {
            i = true;
        }
        if (k.au == 4) {
            j = true;
        }
        var l = truncate(Math.round(d.x));
        var m = truncate(Math.round(d.y));
        f = null;
        var n = -1;
        if (h && c != null) {
            var o = l;
            var p = m;
            if (a.gc != 1) {
                o = truncate(Math.round(d.x * a.gc));
                p = truncate(Math.round(d.y * a.gc));
            }
            var q = c.a(o, p);
            if (q == null || q.length == 0) {
                f = null;
                return {
                    ret: null,
                    p5: f
                };
            }
            if ((q[0] > 0 || q[1] > 0 || q[2] > 0) && q[3] == 255) {
                var num2_ = q[2];
                if (num2_ % 4 != 0) {
                    num2_ = num2_ + (4 - (num2_ % 4));
                }
                var num1_ = q[1];
                if (num1_ % 4 != 0) {
                    num1_ = num1_ + (4 - (num1_ % 4));
                }
                var num0_ = q[0];
                if (num0_ % 4 != 0) {
                    num0_ = num0_ + (4 - (num0_ % 4));
                }
                var num_ = 0;
                num_ = (num2_ >> 2);
                num_ = (num_ << 6);
                num_ = (num_ | (num1_ >> 2));
                num_ = (num_ << 6);
                num_ = (num_ | (num0_ >> 2));
                n = truncate(Math.floor((intDivide(num_, 1000))));
                n--;
            }
        }
        var r = null;
        var s = -1;
        if (n >= 0) {
            var t_1 = false;
            var u_1 = 0;
            try {
                for (var _b = __values(fromEnum(b)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var v = _c.value;
                    if (!v.em) {
                        continue;
                    }
                    if (t_1) {
                        break;
                    }
                    if (v.isStacked) {
                        v.ld(function (w) {
                            if (w.hq == n) {
                                r = w;
                                s = u_1;
                                t_1 = true;
                                return false;
                            }
                            return true;
                        });
                    }
                    else if (v.hq == n) {
                        r = v;
                        s = u_1;
                        break;
                    }
                    u_1++;
                }
            }
            catch (e_2_1) {
                e_2 = { error: e_2_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_2)
                        throw e_2.error;
                }
            }
        }
        var w = null;
        if (i) {
            var x = false;
            for (var y = b.count - 1; y >= 0; y--) {
                var z = b._inner[y];
                if (!z.em) {
                    continue;
                }
                var aa = z.b0;
                if (!z.fb(aa.bu, aa.bv, aa)) {
                    continue;
                }
                if (!x && y < s && h && !j) {
                    if (r != null) {
                        w = r;
                        x = true;
                        break;
                    }
                }
                if (z != null && z.bo == 1) {
                    if (z.ex(d, g)) {
                        w = z;
                        break;
                    }
                }
            }
            if (h && !x) {
                if (r != null) {
                    w = r;
                    x = true;
                }
            }
        }
        else {
            w = r;
        }
        if (w != null) {
            var ab = w.at({ $type: Point_$type, x: l, y: m }, g);
            if (ab != null) {
                f = ab;
            }
            return {
                ret: w,
                p5: f
            };
        }
        return {
            ret: null,
            p5: f
        };
    };
    SeriesViewerInteractionManager.prototype.f$g = function (a, b) {
        if (PointUtil.equals(b, null)) {
            return false;
        }
        var c = b.x;
        var d = b.y;
        if (this.j) {
            return true;
        }
        if (c >= a.to.left && d >= a.to.top && c <= a.to.left + a.to.width && d <= a.to.top + a.to.height) {
            var e = a.cn;
            if (e != null && e.viewShouldInteract(b)) {
                return false;
            }
            return true;
        }
        return false;
    };
    SeriesViewerInteractionManager.prototype.c = function (a) {
        if (a != null) {
            return a.bf();
        }
        else {
            return null;
        }
    };
    SeriesViewerInteractionManager.prototype.f$w = function (a, b, c, d, e, f) {
        var _this = this;
        if (!f && a.dn) {
            this.ah(a, false);
        }
        var g = new MouseEventArgs();
        g.position = d;
        if (a.cl == 2 || a.cl == 1 || a.e4 || (a.cn != null && a.cn.isPinching)) {
            if (this.d != null) {
                this.d.a6.a$z(this.d, g.position, this.a, g, f);
                this.d = null;
            }
            return;
        }
        var h = null;
        var i = ((function () { var j = _this.f$d(a, b, c, d, !e, h, f); h = j.p5; return j.ret; })());
        this.a = h;
        var j = this.c(i);
        if (i != null) {
            var k = false;
            var l = false;
            if (this.d != i) {
                l = true;
            }
            if (this.d == null || l) {
                k = true;
            }
            if (k) {
                if (l) {
                    if (this.d != null) {
                        j = this.c(this.d);
                        this.d.a6.a$z(this.d, g.position, h, g, f);
                        if (j != null) {
                            j.a6.a$z(j, g.position, h, g, f);
                        }
                    }
                }
                this.d = i;
                i.lz(g.position, h, g, f);
                if (j != null) {
                    j.lz(g.position, h, g, f);
                }
            }
            else {
                this.d = i;
                i.a6.a$ab(i, g.position, h, g, f);
                if (j != null) {
                    j.a6.a$ab(j, g.position, h, g, f);
                }
            }
        }
        else {
            if (this.d != null) {
                j = this.c(this.d);
                this.d.a6.a$z(this.d, g.position, h, g, f);
                if (j != null) {
                    j.a6.a$z(j, g.position, h, g, f);
                }
                this.d = null;
            }
            for (var m = 0; m < a.series.count; m++) {
                var n = a.series._inner[m];
                if (n.a6.a$b) {
                    j = this.c(n);
                    n.a6.a$z(n, g.position, n.a6.a$p, g, f);
                    if (j != null) {
                        j.a6.a$z(j, g.position, n.a6.a$p, g, f);
                    }
                }
            }
        }
    };
    SeriesViewerInteractionManager.prototype.f$v = function (a, b) {
        if (this.d != null) {
            var c = this.c(this.d);
            var d = new MouseEventArgs();
            d.position = b;
            this.d.a6.a$z(this.d, d.position, null, d, false);
            if (c != null) {
                c.a6.a$z(c, d.position, null, d, false);
            }
            this.d = null;
        }
        a.nb(b, a.cl != 0 || a.ev);
    };
    SeriesViewerInteractionManager.prototype.f$u = function (a, b, c) {
        if (this.d != null) {
            var d = new MouseButtonEventArgs();
            d.position = c;
            if (b.al) {
                this.d.a6.a$ac(this.d, d.position, this.a, d);
            }
            else {
                this.d.a6.a$w(this.d, d.position, this.a, d);
            }
        }
    };
    SeriesViewerInteractionManager.prototype.f$x = function (a, b, c) {
        var d;
        var e = (this.d != null) ? this.d : ((function () { var f = a.cu.f(c, false, d, false); d = f.p2; return f.ret; })());
        if (e != null) {
            var f = new MouseButtonEventArgs();
            f.position = c;
            if (b.al) {
                e.a6.a$ad(e, f.position, this.a, f);
            }
            else {
                e.a6.a$aa(e, f.position, this.a, f);
            }
        }
    };
    SeriesViewerInteractionManager.prototype.f$t = function (a, b, c) {
        if (!c && a.ex) {
            this.ah(a, false);
        }
        if (c && !a.ex) {
            this.ah(a, true);
        }
        a.mt(b, c);
    };
    SeriesViewerInteractionManager.prototype.ah = function (a, b) {
        if (a != null) {
            if (!this.k) {
                a.dn = b;
            }
        }
    };
    SeriesViewerInteractionManager.prototype.f$aa = function (a, b) {
        this.h = true;
    };
    Object.defineProperty(SeriesViewerInteractionManager.prototype, "k", {
        get: function () {
            return this.h;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewerInteractionManager.$t = markType(SeriesViewerInteractionManager, 'SeriesViewerInteractionManager', Base.$, [ISeriesViewerInteractionManager_$type]);
    return SeriesViewerInteractionManager;
}(Base));
export { SeriesViewerInteractionManager };
